import { useQuery, QueryHookOptions } from '@companyon/graphql';
import { GET_ACTIVE_BUSINESSES_QUERY } from '../../schema/queries/getActiveBusinesses';

export function useGetActiveBusinessesQuery(options?: QueryHookOptions) {
  return useQuery(GET_ACTIVE_BUSINESSES_QUERY, options);
}
